<template>
  <div class="my-card">
    <div
      v-if="isLoading"
      class="progress mb-1"
    >
      <div
        class="progress-bar progress-bar-striped progress-bar-animated"
        style="width:100%"
      />
    </div>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :total-rows="totalRows"
      class="custom-table"
      mode="remote"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
      @on-column-filter="onColumnFilter"
      @on-sort-change="onSortChange"
    >
      <template #table-actions>
        <div class="w-100 d-flex flex-wrap align-items-center justify-content-between gap-2">
          <div class="m-1">

            <flat-pickr
              v-model="dateRange"
              :config="{ mode: 'range', enableTime: false, dateFormat: 'Y-m-d'}"
              placeholder="Filter Tanggal"
              class="form-control bg-white"
              @on-change="onDateChange"
            />

          </div>
          <div class="m-1">
            <b-button
              variant="primary"
              class="mr-1"
              :to="{name: 'toko-cashier-add'}"
            >
              Tambah Penjualan
            </b-button>
            <b-button
              v-b-modal.modal-presales
              variant="success"
              class="mr-1"
            >
              Pilih Pesanan
            </b-button>
          </div>
        </div>

      </template>
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item :to="{ name: 'toko-sales-preview', params: {id: props.row['id']} }">
                <feather-icon
                  icon="PrinterIcon"
                  class="mr-50"
                />
                <span>Cetak</span>
              </b-dropdown-item>
              <div v-if="(props.row['trx_status_code'] != 'R' && props.row['trx_status_code'] != 'C')">
                <b-dropdown-item
                  v-if="props.row['payment_status_code'] != 2 && props.row['payment_total'] < 0 || !props.row['payment_total']"
                  :to="{ name: 'toko-sales-edit', params: {id: props.row['id']} }"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-50"
                  />
                  <span>Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="props.row['payment_total'] > 0 && props.row['trx_status_code'] != 'R'"
                  v-b-modal.modal-refund
                  @click="openRefundModal(props.row['id'], props.row['payment_total'], props.row['trx_no'])"
                >
                  <feather-icon
                    icon="ThumbsDownIcon"
                    class="mr-50"
                  />
                  <span>Refund</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="(props.row['payment_total'] == 0 || props.row['payment_total'] == null) && props.row['trx_status_code'] != 'C'"
                  v-b-modal.modal-cancel
                  @click="openCancelModal(props.row['id'], props.row['grand_total'], props.row['trx_no'])"
                >
                  <feather-icon
                    icon="XCircleIcon"
                    class="mr-50"
                  />
                  <span>Batal</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="props.row['payment_status_code'] != 2 && (props.row['trx_status_code'] != 'R' && props.row['trx_status_code'] != 'C')"
                  v-b-modal.modal-payment
                  @click="openPayModal(props.row['id'], props.row['payment_outs'], props.row['trx_no'])"
                >
                  <feather-icon
                    icon="CreditCardIcon"
                    class="mr-50"
                  />
                  <span>Bayar</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="props.row['prod_code'] == '3' && props.row['trx_status_code'] != 'F'"
                  @click="handleShipping(props.row['trx_status_code'], props.row['id'], props.row['payment_status_code'], props.row['shipping_id'])"
                >
                  <feather-icon
                    icon="NavigationIcon"
                    class="mr-50"
                  />
                  <span v-if="props.row['trx_status_code'] === 'E' && props.row['shipping_id'] != 1">Kirim Barang</span>
                  <span v-else-if="(props.row['trx_status_code'] === 'S' || props.row['trx_status_code'] === 'E')">Update Status Selesai</span>
                </b-dropdown-item>
              </div>
            </b-dropdown>
          </span>
        </span>

        <span v-else-if="props.column.field=== 'grand_total'">
          {{ new Intl.NumberFormat('en-US').format(props.formattedRow[props.column.field]) }}
        </span>

        <span v-else-if="props.column.field=== 'payment_outs'">
          {{ new Intl.NumberFormat('en-US').format(props.formattedRow[props.column.field]) }}
        </span>

        <span v-else-if="props.column.field=== 'trx_status'">
          <template v-if="props.formattedRow[props.column.field] === 'Selesai'">
            <a
              :href="buildWhatsAppLink(props.formattedRow)"
              target="_blank"
              style="text-decoration: none"
            >
              <b-badge
                pill
                :variant="trxStatusVariant[props.formattedRow[props.column.field]]"
              >
                {{ props.formattedRow[props.column.field] }}
              </b-badge>
            </a>
          </template>
          <template v-else>
            <b-badge
              pill
              :variant="trxStatusVariant[props.formattedRow[props.column.field]]"
            >
              {{ props.formattedRow[props.column.field] }}
            </b-badge>
          </template>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <!-- modal payment -->
    <b-modal
      id="modal-payment"
      v-model="showPaymentModal"
      ok-only
      ok-title="Tutup"
      centered
      size="lg"
      :title="`Bayar Tagihan #${payment.trx_no}`"
    >
      <b-card-body>
        <div class="mt-2">
          <!-- Source Payment -->
          <b-form-group
            label="Sumber Pembayaran"
            label-for="payment_bank"
            class="w-100"
          >
            <b-form-input
              id="payment_bank"
              v-model="payment.payment_bank"
              type="text"
              value="0"
              placeholder="Masukkan Sumber Pembayaran (Tunai/BCA/BRI, dll)"
            />
          </b-form-group>

          <!-- Payment To -->
          <b-form-group
            label="Pembayaran ke Kas/Bank"
            label-for="payment-method"
          >
            <v-select
              v-model="payment.cash_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="cashOpt"
              label="cash"
              input-id="payment-method"
              class="payment-selector"
              :clearable="false"
            />
          </b-form-group>

          <!-- Down Payment or Full Payment -->

          <b-form-group
            label="Sisa Tagihan"
            label-for="outs_bill"
          >
            <b-form-input
              id="outs_bill"
              :value="new Intl.NumberFormat('en-US').format(payment.outs_bill)"
              type="text"
              readonly
            />
          </b-form-group>

          <b-form-group
            label="Total Bayar"
            label-for="paid_bill"
          >
            <cleave
              v-model="payment.paid_bill"
              :raw="true"
              class="form-control"
              :options="currencyOptions"
              @input="handleTotalPaid()"
            />
          </b-form-group>

          <b-form-group
            label="Kembalian"
            label-for="back_bill"
          >
            <b-form-input
              id="back_bill"
              :value="new Intl.NumberFormat('en-US').format(payment.back_bill)"
              readonly
            />
          </b-form-group>

          <b-button
            variant="success"
            @click="handlePayment()"
          >
            Bayar
          </b-button>

        </div>
      </b-card-body>
    </b-modal>

    <!-- modal refund -->
    <b-modal
      id="modal-refund"
      v-model="showRefundModal"
      ok-only
      ok-title="Tutup"
      centered
      size="lg"
      :title="`Refund #${refund.trx_no}`"
    >
      <b-card-body>
        <div class="mt-2">
          <!-- Source Payment -->
          <b-form-group
            label="Sumber Pengembalian Dana"
            label-for="refund-source"
            class="w-100"
          >
            <v-select
              v-model="refund.cash_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="cashOpt"
              label="cash"
              input-id="refund-source"
              class="payment-selector"
              :clearable="false"
            />
          </b-form-group>

          <!-- Payment To -->
          <b-form-group
            :label="`Nominal Dana (Max. ${new Intl.NumberFormat('en-US').format(refund.total_paid)})`"
            label-for="payment-method"
          >
            <cleave
              id="refund-total"
              v-model="refund.grand_total"
              type="text"
              placeholder="Masukkan Nilai Pengembalian"
              :raw="true"
              class="form-control"
              :options="currencyOptions"
            />
          </b-form-group>

          <b-form-group
            label="Alasan Retur"
          >
            <b-form-textarea
              v-model="refund.other_reason"
              row="1"
              class="mb-2 mb-lg-0"
            />
          </b-form-group>

          <b-button
            variant="success"
            @click="handleRefund()"
          >
            Bayar Retur
          </b-button>

        </div>
      </b-card-body>
    </b-modal>

    <!-- modal batal -->
    <b-modal
      id="modal-cancel"
      v-model="showCancelModal"
      ok-only
      ok-title="Tutup"
      centered
      size="lg"
      :title="`Batal #${cancel.trx_no}`"
    >
      <b-card-body>
        <div class="mt-2">
          <b-form-group
            label="Alasan Batal"
          >
            <b-form-textarea
              v-model="cancel.other_reason"
              row="1"
              class="mb-2 mb-lg-0"
            />
          </b-form-group>

          <b-button
            variant="danger"
            @click="handleCancel()"
          >
            Batalkan Penjualan
          </b-button>

        </div>
      </b-card-body>
    </b-modal>

    <!-- modal presales -->
    <b-modal
      id="modal-presales"
      ok-only
      ok-title="Tutup"
      centered
      size="lg"
      title="Pilih Pesanan"
    >
      <b-card-body>
        <div class="mt-2">
          <b-row class="mb-2">
            <b-col>
              <b-form-input
                v-model="presalesTable.filters.ps_no"
                placeholder="Cari No Pesanan"
                @input="presalesFilter"
              />
            </b-col>
            <b-col>
              <b-form-input
                v-model="presalesTable.filters.customer"
                placeholder="Cari Nama Pelanggan"
                @input="presalesFilter"
              />
            </b-col>
          </b-row>
          <!-- Source Presales -->
          <b-table-lite
            responsive
            :items="presalesData"
            :fields="[
              { key: 'actions', label: 'Aksi' },
              { key: 'ps_no', label: 'No Pesanan' },
              { key: 'customer', label: 'Pelanggan' },
              { key: 'ps_date', label: 'Tanggal Pesanan' },
            ]"
          >

            <template #cell(actions)="data">
              <b-button
                variant="success"
                @click="presalesId = data.item.ps_no; handleOrder()"
              >
                Pilih
              </b-button>
            </template>

          </b-table-lite>

          <!-- Pagination Controls -->
          <b-pagination
            v-model="presalesTable.currentPage"
            :per-page="presalesTable.perPage"
            :total-rows="presalesTable.totalRows"
            align="center"
            @input="getPresalesData"
          />

        </div>
      </b-card-body>
    </b-modal>
    <PrintNota
      v-if="activeId"
      ref="nota"
      class="d-none"
      :active-id="activeId"
      :payment="payment"
    />
  </div>
</template>

<script>
import {
  BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
  BButton, BModal, BCardBody, BTableLite, BRow, BCol, BFormTextarea, BBadge,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import PrintNota from '@/views/feature/PrintNotaBayar.vue'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BBadge,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BModal,
    BCardBody,
    vSelect,
    PrintNota,
    flatPickr,
    BTableLite,
    BRow,
    BCol,
  },
  data() {
    return {
      isLoading: false,
      currencyOptions: this.$currencyOptions.number,
      pageLength: 10,
      dir: false,
      showPaymentModal: false,
      showRefundModal: false,
      showCancelModal: false,
      company: {
        company_name: '',
        company_phone: '',
        company_address: '',
      },
      columns: [
        {
          field: 'trx_no',
          label: 'No Transaksi',
          filterOptions: {
            enabled: true,
            placeholder: 'Cari No Transaksi',
          },
        },
        {
          field: 'trx_date',
          label: 'Tanggal',
          // filterOptions bisa disiapkan jika ingin date range
        },
        {
          field: 'phone',
          label: 'Nomor',
          sortable: false,
          hidden: true, // untuk beberapa komponen seperti vue-good-table
        },

        {
          field: 'customer',
          label: 'Pelanggan',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Cari pelanggan',
          },
        },
        {
          field: 'payment_outs',
          label: 'Kurang Bayar',
          sortable: false,
        },
        {
          field: 'payment_status',
          label: 'Status Bayar',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Pilih Status',
            filterDropdownItems: [
              { value: '1', text: 'Belum Lunas' },
              { value: '2', text: 'Lunas' },
            ],
          },
        },
        {
          field: 'payment_due',
          label: 'Jatuh Tempo',
          // optional date filter
        },
        {
          field: 'desc',
          label: 'Keterangan',
        },
        {
          field: 'grand_total',
          label: 'Total',
        },
        {
          field: 'trx_status',
          label: 'Status Transaksi',
          filterOptions: {
            enabled: true,
            placeholder: 'Pilih Status',
            filterDropdownItems: [
              { value: 'E', text: 'Dibuat' },
              { value: 'S', text: 'Dikirim' },
              { value: 'F', text: 'Selesai' },
              { value: 'R', text: 'Refund' },
              { value: 'C', text: 'Batal' },
            ],
          },
        },
        {
          field: 'prod_status',
          label: 'Workshop',
        },
        {
          field: 'action',
          label: 'Action',
          sortable: false,
        },
      ],
      rows: [],
      totalRows: 0,
      serverParams: {
        page: 1,
        perPage: 10,
        search: '',
        sort: {
          field: null,
          type: null,
        },
        filters: {
        },
      },
      dateRange: null,
      searchTerm: '',
      cashOpt: [],
      payment: {
        cash_id: {
          cash: null,
          value: null,
        },
        total_paid: 0,
        outs_bill: 0,
        paid_bill: 0,
        back_bill: 0,
        trx_no: '',
      },
      refund: {
        cash_id: {
          cash: null,
          value: null,
        },
        total_paid: 0,
        grand_total: 0,
        other_reason: '',
        trx_no: '',
      },
      cancel: {
        grand_total: 0,
        other_reason: '',
        trx_no: '',
      },
      presalesId: '',
      presalesData: [],
      presalesTable: {
        filters: {
          ps_no: '',
          customer: '',
        },
        currentPage: 1,
        perPage: 5,
        totalRows: 0,
      },
      printDataReady: false,
      activeId: null,
      trxStatus: {
        E: 'Dibuat',
        S: 'Dikirim',
        F: 'Selesai',
        R: 'Retur',
        C: 'Batal',
      },
      trxStatusVariant: {
        Dibuat: 'secondary',
        Dikirim: 'warning',
        Selesai: 'success',
        Retur: 'danger',
        Batal: 'danger',
      },
      prodStatus: {
        1: 'DALAM ANTRIAN',
        2: 'DALAM PENGERJAAN',
        3: 'SELESAI',
      },
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'refund.grand_total': function (newVal) {
      const numericVal = Number(String(newVal).replace(/[^0-9]/g, ''))
      if (numericVal > this.refund.total_paid) {
        this.refund.grand_total = this.refund.total_paid
      }
    },
  },
  created() {
    this.$http.get('/cashmaster')
      .then(res => {
        this.cashOpt = res.data.data.map(cash => ({
          value: cash.id,
          cash: cash.name,
        }))
      })
    this.getCompanyInfo()
  },
  mounted() {
    this.getOrderData()
    this.getPresalesData()
  },
  methods: {
    getOrderData() {
      this.isLoading = true
      this.$http.get('/cashier/list', {
        params: {
          page: this.serverParams.page,
          per_page: this.serverParams.perPage,
          sort: this.serverParams.sort.field,
          sort_type: this.serverParams.sort.type,
          ...this.serverParams.filters,
          ...this.serverParams.date,
        },
      })
        .then(res => {
          this.rows = res.data.data.map(so => ({
            id: so.id,
            trx_no: so.trx_no,
            trx_date: so.trx_date,
            customer: so.customer.name,
            phone: so.customer.phone,
            payment_outs: (so.grand_total - (so.payments_sum_nominal == null ? 0 : so.payments_sum_nominal)),
            payment_total: so.payments_sum_nominal,
            payment_status: so.payment_status === 1 ? 'Belum Lunas' : 'Lunas',
            payment_status_code: so.payment_status,
            payment_due: so.payment_due,
            desc: so.desc,
            shipping_id: so.shipping_id,
            grand_total: (so.grand_total),
            trx_status_code: so.trx_status,
            trx_status: this.trxStatus[so.trx_status],
            prod_code: so.prod_id,
            prod_status: this.prodStatus[so.prod_id],
          }))

          this.totalRows = res.data.total
        }).finally(() => {
          this.isLoading = false
        })
    },
    onSearch(search) {
      if (search.searchTerm === '') {
        this.serverParams.search = ''
        this.serverParams.page = 1 // reset ke halaman 1
        this.getOrderData()
        return
      }
      if (search.searchTerm.length < 3) return

      this.serverParams.search = search.searchTerm
      this.serverParams.page = 1 // reset ke halaman 1
      this.getOrderData()
    },
    onPageChange(params) {
      this.serverParams.page = params.currentPage
      this.getOrderData()
    },
    onPerPageChange(params) {
      this.serverParams.perPage = params.currentPerPage
      this.getOrderData()
    },
    onColumnFilter(filter) {
      // Ambil semua filter kolom yang aktif
      const filters = filter.columnFilters

      // Simpan ke state serverParams
      this.serverParams.filters = { ...filters }

      // Reset ke page 1
      this.serverParams.page = 1

      // Fetch data lagi
      this.getOrderData()
    },
    onSortChange(params) {
    // contoh: params = { field: 'created_at', type: 'asc' }
      this.serverParams.sort = {
        field: params[0].field,
        type: params[0].type,
      }

      this.getOrderData() // fetch lagi
    },
    formatDateLocal(d) {
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    onDateChange(selectedDates) {
      if (selectedDates.length === 2) {
        const filters = {
          trx_date_from: this.formatDateLocal(selectedDates[0]),
          trx_date_to: this.formatDateLocal(selectedDates[1]),
        }
        this.serverParams.date = { ...filters }
      } else {
        this.serverParams.date = {}
      }

      this.serverParams.page = 1
      this.getOrderData()
    },

    getPresalesData() {
      this.$http.get('/cashier/presales', {
        params: {
          page: this.presalesTable.currentPage,
          per_page: this.presalesTable.perPage,
          ...this.presalesTable.filters,
        },
      })
        .then(res => {
          console.log(res.data.data)
          this.presalesData = res.data.data.map(ps => ({
            ps_no: ps.ps_no,
            customer: ps.customer?.name?.trim() || '-',
            ps_date: ps.ps_date,
          }))

          this.presalesTable.totalRows = res.data.total
        })
    },
    presalesFilter() {
      this.presalesTable.currentPage = 1
      this.getPresalesData()
    },

    openPayModal(id, outsBill, trxNo) {
      this.showPaymentModal = true
      this.payment.outs_bill = outsBill
      this.payment.trx_no = trxNo
      this.activeId = id
    },
    openRefundModal(id, totalPaid, trxNo) {
      this.showRefundModal = true
      this.refund.total_paid = totalPaid
      this.refund.trx_no = trxNo
    },
    openCancelModal(id, billTotal, trxNo) {
      this.showCancelModal = true
      this.cancel.trx_no = trxNo
      this.cancel.grand_total = billTotal
    },
    formatPrice(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    handleShipping(status, id, paymentStatus, shipping) {
      if (status === 'S') {
        this.confirmButtonColor(id)
      } else if (status === 'E') {
        if (paymentStatus !== 2) {
          this.$bvToast.toast('Pembayaran untuk pesanan ini belum lunas!', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })

          return
        }

        if (shipping !== 1) {
          this.$http.put(`/cashier/sales/status/${id}`, { status: 'S' }).then(() => this.$swal({
            icon: 'success',
            title: 'Barang Dalam Pengiriman!',
            text: 'Status Penjualan diperbarui menjadi Dikirim',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          }).then(() => {
            this.getOrderData()
          }))
        } else {
          this.confirmButtonColor(id)
        }
      } else {
        this.$bvToast.toast('Pesanan Telah Selesai!', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },
    confirmButtonColor(id) {
      this.$swal({
        title: 'Apakah Anda yakin untuk selesaikan penjualan?',
        text: 'Anda tidak bisa merubah kembali status ini!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Penjualan Selesai',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$http.put(`/cashier/sales/status/${id}`, { status: 'F' }).then(() => this.$swal({
            icon: 'success',
            title: 'Penjualan Selesai!',
            text: 'Status Penjualan diperbarui menjadi Selesai',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          }).then(() => {
            this.getOrderData()
          }))
        } else if (result.dismiss === 'cancel') {
          this.$swal({
            title: 'Aksi Dibatalkan',
            text: 'Status Penjualan tidak diperbarui',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    handlePayment() {
      const payload = {
        total_paid: this.payment.total_paid,
        cash_id: this.payment.cash_id.value,
        payment_bank: this.payment.payment_bank,
      }
      this.$http.post(`/cashier/payment/${this.activeId}`, payload)
        .then(() => {
          this.$bvToast.toast('Berhasil Bayar Tagihan Penjualan!', {
            title: 'Success',
            variant: 'success',
            solid: true,
          })
          // Biarkan printer jalan dulu sebentar
          const RenderPrint = new Promise(resolve => setTimeout(resolve, 100))

          RenderPrint.then(() => {
            this.getOrderData()
            this.showPaymentModal = false
            this.printThermalInvoice()

            // Baru reset setelah semua beres
            this.payment = {
              cash_id: {
                cash: null,
                value: null,
              },
              total_paid: 0,
              payment_bank: null,
            }
          })
        }).catch(error => {
          const message = error.response?.data?.message || 'Gagal Bayar Tagihan Penjualan!'

          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
          this.showPaymentModal = false
        })
    },
    handleRefund() {
      const payload = {
        cash_id: this.refund.cash_id.value,
        grand_total: this.refund.grand_total,
        no_reff: this.refund.trx_no,
        other_reason: this.refund.other_reason,
      }
      this.$http.post('/cashier/refund', payload)
        .then(() => {
          this.$bvToast.toast('Berhasil Melakukan Retur Penjualan!', {
            title: 'Success',
            variant: 'success',
            solid: true,
          })
          // Biarkan printer jalan dulu sebentar
          const RenderPrint = new Promise(resolve => setTimeout(resolve, 100))

          RenderPrint.then(() => {
            this.getOrderData()
            this.showPaymentModal = false
            this.printThermalInvoice()

            // Baru reset setelah semua beres
            this.refund = {
              cash_id: {
                cash: null,
                value: null,
              },
              total_paid: 0,
              grand_total: null,
              other_reason: null,
            }
          })

          this.showRefundModal = false
        }).catch(error => {
          const message = error.response?.data?.message || 'Gagal Retur Penjualan!'

          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
          this.showRefundModal = false
        })
    },
    handleCancel() {
      const payload = {
        grand_total: this.cancel.grand_total,
        no_reff: this.cancel.trx_no,
        other_reason: this.cancel.other_reason,
      }
      this.$http.post('/cashier/cancel', payload)
        .then(() => {
          this.$bvToast.toast('Berhasil Melakukan Batal Penjualan!', {
            title: 'Success',
            variant: 'success',
            solid: true,
          })

          // Baru reset setelah semua beres
          this.cancel = {
            grand_total: null,
            other_reason: null,
          }

          this.showCancelModal = false
          this.getOrderData()
        }).catch(error => {
          const message = error.response?.data?.message || 'Gagal Batal Penjualan!'

          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
          this.showCancelModal = false
        })
    },
    handleOrder() {
      if (this.presalesId === '') {
        this.$bvToast.toast('Masukkan Kode Pesanan!', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
        return
      }
      this.$http.get(`/cashier/presales/find/${this.presalesId}`)
        .then(res => {
          this.$router.push({ name: 'toko-cashier-presales', params: { id: res.data } })
        }).catch(error => {
          const message = error.response?.data?.message || 'Gagal Order dari Pesanan!'

          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    getCompanyInfo() {
      this.$http.get('/company')
        .then(res => {
          this.company = { ...res.data.data }
        })
        .catch(err => {
          console.error('Gagal ambil data perusahaan', err)
        })
    },
    handleTotalPaid() {
      this.payment.total_paid = this.payment.paid_bill - (this.payment.paid_bill - this.payment.outs_bill) * (this.payment.paid_bill > this.payment.outs_bill ? 1 : 0)
      this.payment.back_bill = (this.payment.paid_bill - this.payment.outs_bill) * (this.payment.paid_bill > this.payment.outs_bill ? 1 : 0)
    },
    printThermalInvoice() {
      this.$refs.nota.print()
    },
    buildWhatsAppLink(row) {
      const nomor = row.phone
      const nama = row.customer
      const trx = row.trx_no
      const totalNota = this.formatRupiah(row.grand_total)
      const totalBayar = this.formatRupiah(row.payment_total ?? 0)
      const sisaBayar = this.formatRupiah(row.payment_outs ?? 0)
      const perusahaan = this.company.name

      const pesan = `
        Halo Kak ${nama},

        Pesanan dengan nomor transaksi *${trx}* telah *selesai*.

        Total Nota : ${totalNota}  
        Total Bayar : ${totalBayar}  
        Sisa Bayar : ${sisaBayar}

        Terima kasih telah berbelanja di *${perusahaan}*.


        Salam,
        Tim Kasir
    `.trim()

      return `https://wa.me/${nomor}?text=${encodeURIComponent(pesan)}`
    },

    formatRupiah(value) {
      const number = Number(value)
      if (Number.isInteger(number)) {
        return `Rp${number.toLocaleString('id-ID', { minimumFractionDigits: 0 })}`
      }
      return `Rp${number.toLocaleString('id-ID', { minimumFractionDigits: 2 })}`
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.custom-table .vgt-table th {
  text-align: center;
  vertical-align: middle;
}

.custom-table .vgt-table td {
  font-size: smaller;
  text-align: center;
}

</style>
